import { ConfigurationLocalAccountingBillableClientsModalRulesItem } from '@/modules/configurationModule/detail/local-accounting/billable/clients/components/clients-modal-rules/configuration-local-accounting-billable-clients-modal-rules.model'
import { StrictNullable } from '@/shared/types/app.types'

export interface ConfigurationLocalAccountingBillableClientsModalRulesVerifyRulesState {
    centerSelected: StrictNullable<ConfigurationLocalAccountingBillableClientsModalRulesItem>
    insurerSelected: StrictNullable<ConfigurationLocalAccountingBillableClientsModalRulesItem>
    petitionerSelected: StrictNullable<ConfigurationLocalAccountingBillableClientsModalRulesItem>
}
export const initialConfigurationLocalAccountingBillableClientsModalRulesVerifyRules =
    (): ConfigurationLocalAccountingBillableClientsModalRulesVerifyRulesState => ({
        centerSelected: null,
        insurerSelected: null,
        petitionerSelected: null
    })
